import { Icon, Tooltip } from '@aloft/toolkit-sui';

import { Flex } from '../../../summary/components/Flex.tsx';
import { Td } from '../../../summary/components/Td.tsx';
import { Tr } from '../../../summary/components/Tr.tsx';
import { Typography } from '../../../summary/components/Typography.tsx';
import { WebOnly } from '../../../summary/components/WebOnly.tsx';
import { TooltipContent } from '../TooltipContent.tsx';
import { COST_APPROACH_COLUMN_WIDTHS } from '../constants.ts';
import { sumPercentWidths } from '../utils/sumPercentWidths.ts';

export const CostApproachSummaryTextRow = ({
  label,
  value,
  tooltip,
  boldValue,
}: {
  label: string;
  value: string;
  tooltip?: string;
  boldValue?: boolean;
}) => (
  <Tr borderTop="1px solid black">
    <Td width={COST_APPROACH_COLUMN_WIDTHS[0]} isFirstColumn>
      <Flex columnGap="5px">
        <Typography variant="body1">{label}</Typography>
        <WebOnly>
          {tooltip && (
            <Tooltip
              placement="top"
              openDelay={500}
              label={<TooltipContent description={tooltip} />}
            >
              <Icon icon="question" size="md" />
              &nbsp;
            </Tooltip>
          )}
        </WebOnly>
      </Flex>
    </Td>
    <Td colSpan={7} width={sumPercentWidths(...COST_APPROACH_COLUMN_WIDTHS.slice(1, 4))}>
      <Flex justifyContent="flex-end">
        <Typography variant={boldValue ? 'h4' : 'body1'} textAlign="right">
          {value}
        </Typography>
      </Flex>
    </Td>
  </Tr>
);
